// Static French content for the FXV Psy site

export const PRACTITIONER = {
  name: "François-Xavier Villette",
  title: "Psychologue – Psychothérapeute",
  city: "Paris 16e",
  phone: "+33619690882",
  phoneDisplay: "06 19 69 08 82",
  email: "fxvpsy@gmail.com",
  address: "Cabinet privé, 75016 Paris",
  doctolibUrl: "https://www.doctolib.fr/psychologue/montfort-l-amaury/francois-xavier-villette",
  mapsEmbed:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2624.586!2d2.275!3d48.860!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e66fd5%3A0x0!2sParis%2016%C3%A8me!5e0!3m2!1sfr!2sfr!4v1700000000000",
};

export const IMAGES = {
  portrait:
    "https://customer-assets.emergentagent.com/job_wellness-mind-paris/artifacts/f9ft77ig_IMG_1285.JPG",
  nature:
    "https://images.unsplash.com/photo-1491929536571-bdbc57e72324?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  office:
    "https://images.unsplash.com/photo-1631248055158-edec7a3c072b?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  hands:
    "https://images.unsplash.com/photo-1604881991720-f91add269bed?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  paris:
    "https://images.unsplash.com/photo-1609885728169-8737a953a103?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  calmWater:
    "https://images.unsplash.com/photo-1500382017468-9049fed747ef?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  forest:
    "https://images.unsplash.com/photo-1448375240586-882707db888b?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  candle:
    "https://images.unsplash.com/photo-1528459801416-a9e53bbf4e17?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
};

export const AREAS = [
  {
    slug: "anxiete-et-crises-d-angoisse",
    short: "Anxiété & crises d'angoisse",
    title: "Anxiété et crises d'angoisse",
    metaTitle: "Anxiété & crises d'angoisse — Psychologue Paris 16e",
    metaDescription:
      "Accompagnement professionnel pour l'anxiété généralisée, les crises d'angoisse et les troubles paniques à Paris 16e et en visioconsultation.",
    keywords: ["anxiété Paris", "crise d'angoisse Paris", "psychologue anxiété Paris 16"],
    hero: "Apaiser durablement l'anxiété et les crises d'angoisse",
    intro:
      "L'anxiété chronique et les crises d'angoisse peuvent peu à peu envahir le quotidien. Un accompagnement adapté permet de comprendre ce qui se joue, d'apprendre à réguler le système nerveux et de retrouver un sentiment de sécurité intérieure.",
    symptomes: [
      "Tensions musculaires, oppression thoracique, palpitations",
      "Ruminations, anticipations négatives, pensées envahissantes",
      "Troubles du sommeil et fatigue diffuse",
      "Sensation de perte de contrôle ou d'irréalité",
      "Évitement progressif de certaines situations sociales ou professionnelles",
    ],
    consequences: [
      "Perte de confiance en soi et repli relationnel",
      "Difficultés de concentration au travail",
      "Impact sur la vie familiale et affective",
      "Risque d'installation de comportements d'évitement",
    ],
    deroulement:
      "L'accompagnement débute par un temps d'écoute pour comprendre votre histoire et identifier les facteurs déclenchants. Selon votre situation, des outils issus de l'EMDR, de l'hypnose, de l'EFT, de la cohérence cardiaque et de la mindfulness sont mobilisés pour apaiser le système nerveux et travailler en profondeur les schémas anxieux.",
    benefices: [
      "Diminution de l'intensité et de la fréquence des crises",
      "Meilleure régulation émotionnelle au quotidien",
      "Reprise d'activités évitées",
      "Sentiment durable de sécurité intérieure",
    ],
  },
  {
    slug: "psychotraumatismes",
    short: "Psychotraumatismes",
    title: "Psychotraumatismes",
    metaTitle: "Psychotraumatisme — Thérapeute EMDR Paris 16e",
    metaDescription:
      "Prise en charge des psychotraumatismes simples et complexes avec EMDR et approches intégratives à Paris 16e.",
    keywords: ["psychotraumatisme Paris", "EMDR Paris", "trauma thérapie Paris"],
    hero: "Traverser et dépasser un événement traumatique",
    intro:
      "Un événement traumatique — accident, agression, deuil, événement médical, violences — peut laisser des empreintes durables. Un travail spécifique permet de désensibiliser ces souvenirs et de retrouver un fonctionnement émotionnel apaisé.",
    symptomes: [
      "Reviviscences, flashbacks, cauchemars répétés",
      "Hypervigilance, sursauts, irritabilité",
      "Évitement de lieux ou situations rappelant l'événement",
      "Engourdissement émotionnel, sentiment de détachement",
      "Honte, culpabilité, perte d'estime de soi",
    ],
    consequences: [
      "Repli social et isolement",
      "Altération des relations affectives",
      "Difficultés professionnelles et de concentration",
      "Comportements de compensation (alimentation, sommeil, substances)",
    ],
    deroulement:
      "Une phase de stabilisation et de ressources est mise en place avant tout retraitement. L'EMDR, l'hypnose et des protocoles intégratifs sont utilisés dans un cadre sécurisant et progressif, à votre rythme.",
    benefices: [
      "Diminution de l'intensité émotionnelle liée au souvenir",
      "Atténuation des reviviscences et cauchemars",
      "Reprise de sentiment de sécurité",
      "Retour à une vie relationnelle et professionnelle plus sereine",
    ],
  },
  {
    slug: "burn-out-et-epuisement-professionnel",
    short: "Burn-out & épuisement",
    title: "Burn-out et épuisement professionnel",
    metaTitle: "Burn-out & épuisement professionnel — Psychologue Paris 16e",
    metaDescription:
      "Accompagnement du burn-out et de l'épuisement professionnel à Paris 16e. Approche clinique et intégrative.",
    keywords: ["burn-out Paris", "épuisement professionnel Paris", "psychologue burn-out"],
    hero: "Sortir du burn-out et retrouver son énergie",
    intro:
      "Le burn-out est un effondrement progressif lié à un stress professionnel prolongé. L'accompagnement vise à comprendre les mécanismes en jeu, à restaurer les ressources et à reconstruire un rapport plus juste au travail.",
    symptomes: [
      "Fatigue persistante non soulagée par le repos",
      "Désengagement émotionnel, cynisme",
      "Perte de sens et de motivation",
      "Troubles cognitifs (mémoire, concentration)",
      "Symptômes physiques : douleurs, troubles du sommeil",
    ],
    consequences: [
      "Arrêts de travail prolongés",
      "Effritement des relations personnelles et professionnelles",
      "Risque de dépression réactionnelle",
      "Perte de confiance dans ses compétences",
    ],
    deroulement:
      "Le travail se déroule en trois temps : repérer les signaux et soutenir la phase de récupération, comprendre l'histoire personnelle et professionnelle qui a conduit à l'épuisement, puis préparer un retour à l'activité aligné avec ses valeurs.",
    benefices: [
      "Restauration de l'énergie vitale",
      "Clarification de ses besoins et limites",
      "Outils concrets pour prévenir la rechute",
      "Réajustement du rapport au travail",
    ],
  },
  {
    slug: "troubles-psychosomatiques",
    short: "Troubles psychosomatiques",
    title: "Troubles psychosomatiques",
    metaTitle: "Troubles psychosomatiques — Psychothérapeute Paris 16e",
    metaDescription:
      "Approche intégrative des troubles psychosomatiques : douleurs, troubles digestifs, dermatologiques. Paris 16e.",
    keywords: ["psychosomatique Paris", "douleurs chroniques psychologue"],
    hero: "Quand le corps exprime ce que les mots n'ont pas dit",
    intro:
      "Les troubles psychosomatiques sont des manifestations corporelles dans lesquelles les facteurs émotionnels jouent un rôle. Un accompagnement permet d'explorer le lien corps-esprit et de soulager durablement les symptômes.",
    symptomes: [
      "Douleurs chroniques sans cause organique identifiée",
      "Troubles digestifs fonctionnels",
      "Manifestations dermatologiques (eczéma, urticaire)",
      "Troubles du sommeil, tensions musculaires",
      "Fatigue inexpliquée",
    ],
    consequences: [
      "Errance médicale et sentiment d'incompréhension",
      "Impact sur la qualité de vie au quotidien",
      "Baisse d'énergie et altération de l'humeur",
      "Difficulté à reconnaître ses émotions",
    ],
    deroulement:
      "Un dialogue précis est instauré entre le récit du patient, l'écoute du corps et les approches intégratives (hypnose, EFT, cohérence cardiaque). Le travail respecte le rythme du corps et soutient l'expression émotionnelle.",
    benefices: [
      "Diminution de l'intensité des symptômes physiques",
      "Meilleure conscience corporelle",
      "Identification et expression des émotions sous-jacentes",
      "Amélioration globale de la qualité de vie",
    ],
  },
  {
    slug: "separation-et-divorce",
    short: "Séparation & divorce",
    title: "Séparation et divorce",
    metaTitle: "Séparation et divorce — Psychologue Paris 16e",
    metaDescription:
      "Accompagnement psychologique des séparations et divorces. Soutien pour reconstruire après une rupture. Paris 16e.",
    keywords: ["séparation Paris", "divorce psychologue", "rupture amoureuse Paris"],
    hero: "Traverser une séparation et se reconstruire",
    intro:
      "Une séparation est une transition majeure qui mobilise un large spectre d'émotions. L'accompagnement offre un espace pour traverser cette épreuve, comprendre ce qui s'est joué et préparer une nouvelle étape de vie.",
    symptomes: [
      "Tristesse profonde, sentiment de vide",
      "Colère, ressentiment, culpabilité",
      "Anxiété face à l'avenir",
      "Troubles du sommeil et de l'appétit",
      "Perte de repères identitaires",
    ],
    consequences: [
      "Difficultés parentales et conflits autour des enfants",
      "Repli social et perte de confiance affective",
      "Réorganisation matérielle et financière complexe",
      "Risque de répétition de schémas relationnels",
    ],
    deroulement:
      "L'accompagnement traverse les différentes étapes du deuil affectif, explore les attachements et schémas relationnels, et soutient la consolidation d'une nouvelle identité personnelle. Des outils intégratifs facilitent l'apaisement émotionnel.",
    benefices: [
      "Apaisement de la douleur émotionnelle",
      "Clarification de ses besoins et limites",
      "Reconstruction de l'estime de soi",
      "Ouverture vers de nouveaux liens plus sains",
    ],
  },
];

export const METHODS = [
  {
    slug: "psychotherapie-integrative",
    name: "Psychothérapie intégrative",
    metaTitle: "Psychothérapie intégrative — Paris 16e",
    metaDescription:
      "Approche intégrative combinant plusieurs courants thérapeutiques validés pour un accompagnement sur-mesure.",
    objectif:
      "Adapter l'accompagnement à la singularité de chaque personne en s'appuyant sur plusieurs courants thérapeutiques validés.",
    fonctionnement:
      "Le thérapeute mobilise, selon les besoins, des outils issus des thérapies cognitives et comportementales, des thérapies humanistes, des approches corps-esprit et des techniques brèves. Le cadre reste structuré et collaboratif.",
    indications: [
      "Souffrances complexes mêlant plusieurs dimensions",
      "Personnes ayant déjà expérimenté une thérapie sans résultat suffisant",
      "Besoin d'un accompagnement personnalisé et évolutif",
    ],
  },
  {
    slug: "hypnose",
    name: "Hypnose",
    metaTitle: "Hypnose thérapeutique — Paris 16e",
    metaDescription:
      "Hypnose ericksonienne et thérapeutique à Paris 16e pour anxiété, douleurs, addictions et confiance en soi.",
    objectif:
      "Mobiliser les ressources inconscientes de la personne pour favoriser un changement profond et durable.",
    fonctionnement:
      "L'hypnose induit un état modifié de conscience naturel, dans lequel le travail thérapeutique se déploie sur un plan plus profond, en respectant les défenses et le rythme du patient.",
    indications: [
      "Anxiété, phobies spécifiques",
      "Douleurs chroniques et préparation médicale",
      "Confiance en soi, blocages personnels",
      "Sommeil, addictions, comportements alimentaires",
    ],
  },
  {
    slug: "emdr",
    name: "EMDR",
    metaTitle: "EMDR Paris 16e — Désensibilisation et retraitement",
    metaDescription:
      "Thérapie EMDR à Paris 16e pour le traitement des psychotraumatismes simples et complexes.",
    objectif:
      "Retraiter les souvenirs traumatiques qui n'ont pas été correctement intégrés et qui continuent de générer des symptômes.",
    fonctionnement:
      "La thérapie EMDR (Eye Movement Desensitization and Reprocessing) utilise des stimulations bilatérales alternées pour permettre au cerveau de retraiter une information bloquée et de l'intégrer de manière apaisée.",
    indications: [
      "Stress post-traumatique",
      "Souvenirs douloureux récurrents",
      "Phobies, anxiété de performance",
      "Deuils complexes",
    ],
  },
  {
    slug: "pnl",
    name: "PNL",
    metaTitle: "PNL — Programmation Neuro-Linguistique Paris 16e",
    metaDescription:
      "Outils de PNL pour mieux communiquer avec soi-même et avec les autres, modéliser le changement.",
    objectif:
      "Identifier les stratégies mentales et émotionnelles qui sous-tendent nos comportements, et apprendre à les modifier.",
    fonctionnement:
      "La PNL propose un ensemble d'outils précis pour observer, ajuster et reproduire des fonctionnements internes utiles. Elle s'intègre à un travail thérapeutique plus large.",
    indications: [
      "Communication, posture professionnelle",
      "Confiance en soi, prise de parole",
      "Objectifs personnels, transitions de vie",
    ],
  },
  {
    slug: "eft",
    name: "EFT",
    metaTitle: "EFT — Technique de libération émotionnelle Paris 16e",
    metaDescription:
      "EFT à Paris 16e : libération émotionnelle par stimulation de points d'acupression.",
    objectif:
      "Apaiser rapidement une émotion intense en alliant stimulation de points d'acupression et formulation verbale ciblée.",
    fonctionnement:
      "Le praticien guide la personne dans une stimulation douce de points spécifiques, en lien avec une émotion ou un souvenir, pour en diminuer la charge émotionnelle.",
    indications: [
      "Émotions envahissantes (peur, colère, tristesse)",
      "Trac, anxiété de performance",
      "Souvenirs douloureux ponctuels",
      "Outil d'auto-régulation au quotidien",
    ],
  },
  {
    slug: "mindfulness",
    name: "Mindfulness",
    metaTitle: "Mindfulness — Pleine conscience Paris 16e",
    metaDescription:
      "Pratique de la pleine conscience pour réguler le stress et cultiver une présence apaisée.",
    objectif:
      "Développer une qualité d'attention et de présence à soi pour mieux accueillir ses pensées, émotions et sensations.",
    fonctionnement:
      "Des pratiques guidées formelles (méditations) et informelles (intégration au quotidien) sont proposées et adaptées au profil de la personne.",
    indications: [
      "Stress chronique, ruminations",
      "Gestion émotionnelle",
      "Prévention de la rechute dépressive",
      "Amélioration de la concentration",
    ],
  },
  {
    slug: "coherence-cardiaque",
    name: "Cohérence cardiaque",
    metaTitle: "Cohérence cardiaque — Paris 16e",
    metaDescription:
      "Cohérence cardiaque à Paris 16e : pratique respiratoire validée pour réguler le stress.",
    objectif:
      "Réguler le système nerveux autonome par une pratique respiratoire courte, simple et reproductible.",
    fonctionnement:
      "Une respiration guidée à six cycles par minute, pratiquée quelques minutes plusieurs fois par jour, induit une harmonisation entre le rythme cardiaque et la respiration.",
    indications: [
      "Stress, anxiété, hypertension légère",
      "Préparation aux situations à enjeu",
      "Soutien du sommeil",
      "Outil d'hygiène émotionnelle quotidienne",
    ],
  },
  {
    slug: "strannik-psy",
    name: "Strannik Psy",
    metaTitle: "Strannik Psy — Bilan psycho-énergétique Paris 16e",
    metaDescription:
      "Analyse Strannik Psy à Paris 16e pour explorer la dimension psycho-émotionnelle.",
    objectif:
      "Proposer une lecture complémentaire des dynamiques psycho-émotionnelles d'une personne pour affiner l'accompagnement.",
    fonctionnement:
      "L'analyse Strannik Psy s'appuie sur un protocole structuré pour repérer des tendances psycho-émotionnelles. Les résultats nourrissent le travail thérapeutique sans s'y substituer.",
    indications: [
      "Souhait d'une lecture intégrative supplémentaire",
      "Accompagnement long de fond",
      "Travail sur la connaissance de soi",
    ],
  },
  {
    slug: "luminotherapie",
    name: "Luminothérapie",
    metaTitle: "Luminothérapie — Paris 16e",
    metaDescription:
      "Luminothérapie à Paris 16e pour soutenir la régulation des rythmes biologiques.",
    objectif:
      "Soutenir la régulation des rythmes biologiques et de l'humeur par une exposition contrôlée à une lumière adaptée.",
    fonctionnement:
      "Des séances brèves d'exposition à une lumière standardisée sont proposées en complément de la prise en charge psychothérapeutique.",
    indications: [
      "Troubles affectifs saisonniers",
      "Décalages de rythme et sommeil",
      "Soutien complémentaire à un travail psychologique",
    ],
  },
  {
    slug: "holopsonie",
    name: "Holopsonie",
    metaTitle: "Holopsonie — Paris 16e",
    metaDescription:
      "Holopsonie à Paris 16e : approche sonore complémentaire à l'accompagnement psychothérapeutique.",
    objectif:
      "Mobiliser des stimulations sonores spécifiques en soutien d'un travail psychothérapeutique global.",
    fonctionnement:
      "Des protocoles sonores personnalisés sont proposés, en complément de la psychothérapie, dans un cadre clinique structuré.",
    indications: [
      "Soutien à la détente profonde",
      "Accompagnement complémentaire de la psychothérapie",
      "Régulation de l'état de stress",
    ],
  },
];

export const TESTIMONIALS = [
  {
    text: "Le travail entrepris m'a permis de retrouver un sommeil paisible et de regagner confiance dans mes capacités professionnelles. Un accompagnement précis, humain et respectueux.",
    author: "Patiente, 38 ans",
  },
  {
    text: "Après plusieurs mois d'anxiété envahissante, je peux à nouveau prendre le métro et m'exprimer en réunion. Je remercie infiniment ce thérapeute pour son écoute et ses outils.",
    author: "Patient, 45 ans",
  },
  {
    text: "Un cadre rassurant et une approche intégrative qui m'a aidée à traverser une période très difficile suite à un événement traumatique.",
    author: "Patiente, 32 ans",
  },
  {
    text: "La combinaison de l'EMDR et de la cohérence cardiaque a été particulièrement aidante pour sortir de mon burn-out.",
    author: "Patient, 51 ans",
  },
];

export const FAQ = [
  {
    q: "Comment se déroule la première consultation ?",
    a: "Le premier rendez-vous est un temps d'écoute. Il permet de comprendre votre demande, votre histoire et de définir ensemble les objectifs et le cadre du travail thérapeutique. Aucune décision n'est imposée : vous êtes libre de poursuivre ou non.",
  },
  {
    q: "Quelle est la durée d'une séance ?",
    a: "Une séance dure en moyenne 50 minutes. Les séances spécifiques (EMDR, hypnose) peuvent durer jusqu'à 60 à 75 minutes.",
  },
  {
    q: "Quels sont les tarifs ?",
    a: "Les tarifs sont communiqués lors de la prise de contact et restent stables dans la durée. Une note d'honoraires peut être remise à votre demande.",
  },
  {
    q: "Les séances sont-elles remboursées ?",
    a: "Les consultations chez le psychologue libéral ne sont pas remboursées par l'Assurance Maladie en dehors de dispositifs spécifiques. Certaines mutuelles proposent un remboursement partiel : renseignez-vous auprès de la vôtre.",
  },
  {
    q: "La visioconsultation est-elle aussi efficace ?",
    a: "La visioconsultation est une modalité éprouvée pour de nombreux motifs. Le cadre déontologique et thérapeutique y est strictement le même qu'en cabinet. Elle est particulièrement adaptée pour les personnes éloignées, à mobilité réduite ou en déplacement.",
  },
  {
    q: "Combien de séances sont nécessaires ?",
    a: "Cela dépend de votre situation et de vos objectifs. Certains motifs peuvent se travailler en quelques séances, d'autres demandent un suivi plus long. Un point régulier est fait ensemble sur l'évolution.",
  },
  {
    q: "Le secret professionnel est-il garanti ?",
    a: "Oui. Le psychologue est tenu au secret professionnel par le Code de déontologie et le Code pénal. Vos échanges restent strictement confidentiels.",
  },
  {
    q: "Comment prendre rendez-vous ?",
    a: "Vous pouvez prendre rendez-vous via Doctolib, le formulaire de contact sécurisé du site ou par téléphone. Une demande de rappel est également possible.",
  },
];

export const DIFFICULTIES = AREAS.map((a) => ({
  slug: a.slug,
  title: a.short,
  description: a.intro.slice(0, 130) + "…",
}));
